var module = angular.module('octopusApp.library');

module.directive('lifecycleEditor', function() {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'areas/library/lifecycles/views/editor.html'
  };
});





//////////////////
// WEBPACK FOOTER
// ./app/areas/library/lifecycles/directives/lifecycle_editor.js
// module id = 921149899820864
// module chunks = 1